import _ from "lodash";
import {ENABLE_PERSISTENCE_MIDDLEWARE} from "./constant";
import {actionMap} from './persistanceKeys';
import PersistenceService from 'service/PersistenceService';

let previousState = null;
export const persistenceMiddleware = store => next => action => {

    const nextResult = next(action);
    const nextState = store.getState();

    if(action.type != ENABLE_PERSISTENCE_MIDDLEWARE) {

        if (nextState.localPersistence && nextState.localPersistence.middlewareEnabled == true) {
            const persistencePaths = actionMap[action.type];
            if(persistencePaths){
                for(const path of persistencePaths) {

                    let newSource = nextState;
                    let perviousSource = previousState;
                    for(const pathItem of path) {
                        newSource = newSource[pathItem];
                        if(perviousSource !== null){
                            perviousSource = perviousSource[pathItem];
                        }
                    }
                    if(!_.isEqual(newSource, perviousSource)){
                        PersistenceService.setItem('redux_persistence__'+path.join("_"), JSON.stringify(newSource));
                    }
                }
            }
        }
    }

    previousState = nextState;
    return nextResult;
}



// WEBPACK FOOTER //
// ./src/storeState/persistence/middleware.js